import { configureStore, PreloadedState } from '@reduxjs/toolkit';

import { rootReducer, theSourceReducer } from './rootReducer';
import { enrollmentReducer } from 'enrollment/app/rootReducer';

export const setupStore = (preloadedState?: PreloadedState<RootState>) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }),
  });

export type RootState = ReturnType<typeof rootReducer>;
export type TheSourceState = ReturnType<typeof theSourceReducer>;
export type EnrollmentState = ReturnType<typeof enrollmentReducer>;
export type AppStore = ReturnType<typeof setupStore>;
